(function () {
  'use strict';

  var openGuide = null;
  var returnFocus = null;

  function normaliseSize(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '')
      .replace(/^XXXL$/, '3XL')
      .replace(/^XXL$/, '2XL');
  }

  function guideForProduct(productId) {
    var guides = document.querySelectorAll('[data-regista-size-guide]');
    for (var index = 0; index < guides.length; index += 1) {
      if (String(guides[index].getAttribute('data-product-id')) === String(productId)) {
        return guides[index];
      }
    }
    return null;
  }

  function toolsForProduct(productId) {
    var tools = document.querySelectorAll('[data-regista-size-fit-tools]');
    for (var index = 0; index < tools.length; index += 1) {
      if (String(tools[index].getAttribute('data-product-id')) === String(productId)) {
        return tools[index];
      }
    }
    return null;
  }

  function selectedLabel(tools) {
    if (!tools) return '';
    var proxy = tools.querySelector('[data-regista-size-proxy]');
    if (proxy && proxy.selectedIndex >= 0) {
      return proxy.options[proxy.selectedIndex].getAttribute('data-size-label') || proxy.options[proxy.selectedIndex].textContent;
    }
    var current = tools.querySelector('[data-regista-size-current]');
    return current ? current.textContent.replace(/^.*?:\s*/, '') : '';
  }

  function selectChartSize(guide, size) {
    var normalised = normaliseSize(size);
    var rows = guide.querySelectorAll('[data-regista-size-row]');
    var tabs = guide.querySelectorAll('[data-regista-size-tab]');
    var panels = guide.querySelectorAll('[data-regista-size-panel]');
    var matchedTab = null;

    rows.forEach(function (row) {
      row.classList.toggle('is-current', normaliseSize(row.getAttribute('data-regista-size-row')) === normalised);
    });

    tabs.forEach(function (tab) {
      var active = normaliseSize(tab.getAttribute('data-regista-size-tab')) === normalised;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) matchedTab = tab;
    });

    if (!matchedTab && tabs.length) {
      matchedTab = tabs[0];
      tabs.forEach(function (tab, index) {
        tab.classList.toggle('is-active', index === 0);
        tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      });
      normalised = normaliseSize(matchedTab.getAttribute('data-regista-size-tab'));
    }

    panels.forEach(function (panel) {
      panel.classList.toggle('is-active', normaliseSize(panel.getAttribute('data-regista-size-panel')) === normalised);
    });
  }

  function openSizeGuide(trigger) {
    var tools = trigger.closest('[data-regista-size-fit-tools]');
    if (!tools) return;
    var guide = guideForProduct(tools.getAttribute('data-product-id'));
    if (!guide) return;

    if (guide.parentNode !== document.body) document.body.appendChild(guide);
    returnFocus = trigger;
    openGuide = guide;
    selectChartSize(guide, selectedLabel(tools));
    guide.classList.add('is-open');
    guide.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('regista-size-guide-open');
    document.body.classList.add('regista-size-guide-open');

    window.requestAnimationFrame(function () {
      var dialog = guide.querySelector('.regista-size-guide__dialog');
      if (dialog) dialog.focus();
    });
  }

  function closeSizeGuide(guide, restoreFocus) {
    if (!guide) return;
    guide.classList.remove('is-open');
    guide.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('regista-size-guide-open');
    document.body.classList.remove('regista-size-guide-open');
    document.querySelectorAll('[data-regista-size-guide-open][aria-expanded="true"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    openGuide = null;
    if (restoreFocus !== false && returnFocus && document.contains(returnFocus)) returnFocus.focus();
    returnFocus = null;
  }

  function realSizeInputs(tools) {
    var formId = tools.getAttribute('data-form-id');
    var sizeIndex = parseInt(tools.getAttribute('data-size-index'), 10);
    if (!formId || sizeIndex < 0) return [];
    var form = document.getElementById(formId);
    if (!form) return [];
    return Array.prototype.slice.call(form.elements).filter(function (element) {
      if (!element.matches) return false;
      return element.matches('[data-option-position="' + (sizeIndex + 1) + '"]') || element.name === 'option' + (sizeIndex + 1);
    });
  }

  function inputSizeLabel(input) {
    var directLabel = input.getAttribute('data-option-value') || input.getAttribute('data-value');
    if (directLabel) return directLabel;
    var adjacent = input.nextElementSibling;
    if (adjacent && adjacent.textContent) return adjacent.textContent.trim();
    if (input.id) {
      var labels = document.querySelectorAll('label[for]');
      for (var index = 0; index < labels.length; index += 1) {
        if (labels[index].getAttribute('for') === input.id) return labels[index].textContent.trim();
      }
    }
    return input.value;
  }

  function variantPickerForForm(formId) {
    var pickers = document.querySelectorAll('variant-picker');
    for (var index = 0; index < pickers.length; index += 1) {
      if (pickers[index].getAttribute('form-id') === formId || pickers[index].getAttribute('form') === formId) return pickers[index];
    }
    return null;
  }

  function activeOptionValues(form) {
    return Array.prototype.slice.call(form.elements)
      .filter(function (element) { return /^option\d+$/.test(element.name || '') && element.checked; })
      .sort(function (first, second) {
        return parseInt(first.name.replace('option', ''), 10) - parseInt(second.name.replace('option', ''), 10);
      })
      .map(function (element) { return element.value; });
  }

  function hideNativeSizePicker(tools) {
    var proxy = tools.querySelector('[data-regista-size-proxy]');
    if (!proxy) return;
    var inputs = realSizeInputs(tools);
    if (!inputs.length) return;
    var field = inputs[0].closest('.variant-picker__option');
    if (field) field.classList.add('regista-size-native-hidden');
  }

  function applyProxySelection(proxy) {
    var tools = proxy.closest('[data-regista-size-fit-tools]');
    if (!tools || proxy.selectedIndex < 0) return;
    var selectedOption = proxy.options[proxy.selectedIndex];
    var selectedValue = String(proxy.value);
    var selectedText = selectedOption.getAttribute('data-size-label') || selectedOption.textContent.trim();
    var inputs = realSizeInputs(tools);
    var matched = null;

    inputs.forEach(function (input) {
      var inputLabel = inputSizeLabel(input);
      if (String(input.value) === selectedValue || normaliseSize(inputLabel) === normaliseSize(selectedText)) matched = input;
    });

    if (matched) {
      if (matched.type === 'radio') matched.checked = true;
      else matched.value = selectedValue;
      if (matched.hasAttribute('data-option-position')) {
        matched.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        var form = document.getElementById(tools.getAttribute('data-form-id'));
        var picker = variantPickerForForm(tools.getAttribute('data-form-id'));
        if (form && picker && typeof picker.selectCombination === 'function') {
          picker.selectCombination({ optionValues: activeOptionValues(form), productChange: false });
        } else {
          matched.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    var current = tools.querySelector('[data-regista-size-current]');
    if (current) current.textContent = 'מידה נבחרת: ' + selectedText;
  }

  function syncFromVariant(event) {
    var detail = event.detail || {};
    var variant = detail.variant;
    if (!variant || !variant.options) return;
    document.querySelectorAll('[data-regista-size-fit-tools]').forEach(function (tools) {
      if (detail.formId && tools.getAttribute('data-form-id') !== detail.formId) return;
      var sizeIndex = parseInt(tools.getAttribute('data-size-index'), 10);
      if (sizeIndex < 0 || !variant.options[sizeIndex]) return;
      var size = variant.options[sizeIndex];
      var current = tools.querySelector('[data-regista-size-current]');
      var proxy = tools.querySelector('[data-regista-size-proxy]');
      if (current) current.textContent = 'מידה נבחרת: ' + size;
      if (proxy) {
        for (var index = 0; index < proxy.options.length; index += 1) {
          var label = proxy.options[index].getAttribute('data-size-label') || proxy.options[index].textContent;
          if (normaliseSize(label) === normaliseSize(size)) {
            proxy.selectedIndex = index;
            break;
          }
        }
      }
    });
    window.setTimeout(initTools, 0);
  }

  function initTools() {
    document.querySelectorAll('[data-regista-size-fit-tools]').forEach(hideNativeSizePicker);
  }

  function focusableElements(guide) {
    return Array.prototype.slice.call(guide.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (element) { return element.offsetParent !== null; });
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-regista-size-guide-open]');
    if (openTrigger) {
      event.preventDefault();
      openSizeGuide(openTrigger);
      return;
    }

    var closeTrigger = event.target.closest('[data-regista-size-guide-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeSizeGuide(closeTrigger.closest('[data-regista-size-guide]'));
      return;
    }

    var tab = event.target.closest('[data-regista-size-tab]');
    if (tab) {
      event.preventDefault();
      var guide = tab.closest('[data-regista-size-guide]');
      selectChartSize(guide, tab.getAttribute('data-regista-size-tab'));
      return;
    }

    var fitButton = event.target.closest('[data-regista-size-guide-fit]');
    if (fitButton) {
      event.preventDefault();
      var fitGuide = fitButton.closest('[data-regista-size-guide]');
      var productId = fitGuide.getAttribute('data-product-id');
      closeSizeGuide(fitGuide, false);
      window.setTimeout(function () {
        var tools = toolsForProduct(productId);
        var fitTrigger = tools && tools.querySelector('[data-regista-fit-open]');
        if (fitTrigger) fitTrigger.click();
      }, 120);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-regista-size-proxy]')) applyProxySelection(event.target);
  });

  document.addEventListener('keydown', function (event) {
    if (!openGuide) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeSizeGuide(openGuide);
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = focusableElements(openGuide);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('variant:change', syncFromVariant);
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(initTools, 0);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTools);
  else initTools();
})();
